import React from "react"
import { Routes, Route } from "react-router-dom"
import { Box } from "@mui/material"
import AdminRoute from "../components/AdminRoute"
import ProtectedRoute from "./ProtectedRoute"

import HomePage from "../views/home-pages/HomePage"
import NewHomePage from "../views/home-pages/NewHomePage"

//All Inner Page Routes

//All DropDown Page Routes

//All About Page Routes
import AboutMe from "../views/inner-pages/pages/about-us/AboutMe"

//All Service Page Routes


//All Team Page Routes


// Testimonial Page Routes

import Error from "../views/inner-pages/pages/Error"

// All Portfolio Page Routes


// All Blog Page Routes


// Contact Page Routes


// Not Found Page
import NotFound from "../views/NotFound"
import SignUpPage from "../views/SignUpPage"
import ComingSoon from "../views/ComingSoon"
import { SignInPage } from "../views/SignInPage"

// Other components
import SiblingNewsletterPage from "../views/inner-pages/blog/SiblingNewsletterPage"
import MonthlyNewslettersPage from "../views/inner-pages/blog/MonthlyNewslettersPage"
import YearlyNewsletterPage from "../views/inner-pages/blog/YearlyNewsletterPage"
import AllNewslettersPage from "../views/inner-pages/blog/AllNewslettersPage"
import Survey from "../views/Survey/Survey"
import ChoresView from "../views/inner-pages/ChoresView/ChoresView"

import ChoresTouch from "../views/inner-pages/ChoresTouch/ChoresTouch"
import FamilyCentral from "../views/inner-pages/FamilyCentral/FamilyCentral"
import ShoppingListPage from "../views/inner-pages/Grocery/ShoppingListPage"
import GroceryMobileShare from "../views/inner-pages/Grocery/GroceryMobileShare"
import GroceryLiveView from "../views/inner-pages/Grocery/GroceryLiveView"
import MealPlanning from "../views/inner-pages/MealPlanning/MealPlanning"
import TodaysAgenda from "../views/inner-pages/TodaysAgenda/TodaysAgenda"
import Countdown from "../views/Countdown"
import AdvenchoreStoryPage from "../views/inner-pages/StoryView/AdvenchoreStoryPage"
import FamilyTimeline from "../views/inner-pages/TimelineView/FamilyTimeline"
import PictureViewingPage from "../views/inner-pages/pictures/PictureViewingPage"
import FamilyAddressTable from "../views/inner-pages/addresses/FamilyAddressTable"
import TempleAirportTable from "../views/inner-pages/Temples/TempleAirportTable"



import AnimationDemo from "../views/inner-pages/animation/AnimationDemo"
import ConfettiTest from "../views/inner-pages/animation/ConfettiTest"
import ChoreStore from "../views/inner-pages/ChoreStore/ChoreStore"
import PurchaseHistory from "../views/inner-pages/PurchaseHistory/PurchaseHistory"
import AdminPanel from "../views/inner-pages/Admin/AdminPanel"
import MomStoriesAdminDashboard from "../views/inner-pages/Admin/MomStoriesAdminDashboardV2"
import MomAnswerPage from "../views/inner-pages/MomStories/MomAnswerPage"
import MomStoriesFeed from "../views/inner-pages/MomStories/MomStoriesFeed"
import MomStoryDetail from "../views/inner-pages/MomStories/MomStoryDetail"
import MomStoriesQueue from "../views/inner-pages/MomStories/MomStoriesQueue"

import EventIcon from '@mui/icons-material/Event';

import TravelLog from "../views/TravelLog"
import NonRevTravel from "../views/inner-pages/Travel/NonRevTravel"
import CruisePlanning from "../views/inner-pages/Travel/CruisePlanning"
import BuzzerLanding from "../views/inner-pages/Buzzer/BuzzerLanding"
import BuzzerHost from "../views/inner-pages/Buzzer/BuzzerHost"
import BuzzerClient from "../views/inner-pages/Buzzer/BuzzerClient"
import BallparkLanding from "../views/inner-pages/Ballpark/BallparkLanding"
import BallparkGame from "../views/inner-pages/Ballpark/BallparkGame"
import ScattergoriesLanding from "../views/inner-pages/Scattergories/ScattergoriesLanding"
import ScattergoriesGame from "../views/inner-pages/Scattergories/ScattergoriesGame"
import JustOneLanding from "../views/inner-pages/JustOne/JustOneLanding"
import JustOneGame from "../views/inner-pages/JustOne/JustOneGame"
import CalendarPage from "../views/inner-pages/Calendar/CalendarPage"
import CalendarSetupPage from "../views/inner-pages/Calendar/CalendarSetupPage"
import Metronome from "../views/inner-pages/Metronome/Metronome"
// import SamanthaMission from "../views/inner-pages/Missions/SamanthaMission"
import DymockHistory from "../views/inner-pages/DymockHistory/DymockHistory"
import BigReveal from "../views/inner-pages/BigReveal/BigReveal"
import AncestorConverts from "../views/inner-pages/DymockHistory/AncestorConverts"
import FlightsPage from "../views/inner-pages/Flights/FlightsPage"

const AppRouter = () => {
    // Moved placeholder routes definition inside component if they were static, 
    // but we'll specific them inline for clarity.

  return (
    <Box sx={{ height: "100vh" }}>
      <Routes>
        <Route path="/" element={<NewHomePage />} />
        <Route path="/home" element={<NewHomePage />} />
        <Route path="/new" element={<NewHomePage />} />
        <Route path="/cpr" element={<Metronome />} />
        <Route path="/signin" element={<SignInPage />} />
        <Route path="/signup" element={<SignUpPage />} />
        <Route path="/grocery-share" element={<GroceryMobileShare />} />
        <Route path="/calendar-setup" element={<CalendarSetupPage />} />
        

        <Route path="/about-me" element={<AboutMe />} />

        <Route path="/leah" element={<Survey />} />
        {/* Budget page - currently not in use
        <Route
          path="/budget"
          element={
            <ProtectedRoute>
              <BudgetDashboardPage />
            </ProtectedRoute>
          }
        />
        */}
        <Route
          path="/timeline"
          element={
            <ProtectedRoute>
              <FamilyTimeline />
            </ProtectedRoute>
          }
        />

        <Route
          path="/chores"
          element={
            <ProtectedRoute>
              <ChoresTouch />
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/family-central"
          element={
            <ProtectedRoute>
              <FamilyCentral />
            </ProtectedRoute>
          }
        />



        <Route
          path="/grocery"
          element={
            <ProtectedRoute>
              <ShoppingListPage 
                  title="Grocery Request List" 
                  collectionName="groceryItems"
                  validationType="grocery"
                  themeColor="#ed8936"
              />
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/household"
          element={
            <ProtectedRoute>
              <ShoppingListPage 
                  title="Household Supplies" 
                  collectionName="householdItems"
                  validationType="household"
                  themeColor="#3182ce"
              />
            </ProtectedRoute>
          }
        />

        <Route
          path="/leah-grocery-list"
          element={
            <ProtectedRoute>
              <GroceryLiveView />
            </ProtectedRoute>
          }
        />
        


        <Route
          path="/meal-planning"
          element={
            <ProtectedRoute>
              <MealPlanning />
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/agenda"
          element={
            <ProtectedRoute>
              <TodaysAgenda />
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/chores-legacy"
          element={
            <ProtectedRoute>
              <ChoresView />
            </ProtectedRoute>
          }
        />

        

        

                <Route path="/faq" element={<ComingSoon />} />
        {/* <Route path="/faq" element={<FAQ />} /> */}
        <Route path="/error" element={<Error />} />

        {/* <Route path="/blog-grid" element={<GridLayout />} /> */}
        
        {/* <Route path="/blog-future" element={<BlogFutureDynamic />} /> */}
        <Route exact path="/newsletter/" element={<AllNewslettersPage />} />
        <Route
          exact
          path="/newsletter/:year/"
          element={<YearlyNewsletterPage />}
        />
        <Route
          exact
          path="/newsletter/:year/:month/"
          element={<MonthlyNewslettersPage />}
        />
        <Route
          exact
          path="/newsletter/:year/:month/:sibling"
          element={<SiblingNewsletterPage />}
        />

        

        <Route path="/picture-sorting" element={<ComingSoon />} />
        <Route path="/photo-journal" element={<ComingSoon />} />
        {/* <Route path="/come-follow-me" element={<VideoList />} /> */}
        <Route
          path="/advenchore"
          element={
            <ProtectedRoute>
              <AdvenchoreStoryPage />
            </ProtectedRoute>
          }
        />
        <Route path="/retirement" element={<Countdown />} />
        <Route
          path="/viewPictures"
          element={
            <ProtectedRoute>
              <PictureViewingPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/addresses"
          element={
            <ProtectedRoute>
              <FamilyAddressTable />
            </ProtectedRoute>
          }
        />
        <Route
          path="/temples"
          element={
            <ProtectedRoute>
              <TempleAirportTable />
            </ProtectedRoute>
          }
        />


        {/* Expenses page - currently not in use
        <Route
          path="/expenses"
          element={
            <ProtectedRoute>
              <ExpensesPage />
            </ProtectedRoute>
          }
        />
        */}
        <Route path="/animation" element={<AnimationDemo />} />
        <Route path="/confetti" element={<ConfettiTest />} />
        <Route
          path="/chorestore"
          element={
            <ProtectedRoute>
              <ChoreStore />
            </ProtectedRoute>
          }
        />
        <Route
          path="/purchases"
          element={
            <ProtectedRoute>
              <PurchaseHistory />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminRoute>
                <AdminPanel />
              </AdminRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/mom-stories/admin"
          element={
            <ProtectedRoute>
              <AdminRoute>
                <MomStoriesAdminDashboard />
              </AdminRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/mom-stories"
          element={
            <ProtectedRoute>
              <MomStoriesFeed />
            </ProtectedRoute>
          }
        />
        <Route
          path="/mom-stories/story/:storyId"
          element={
            <ProtectedRoute>
              <MomStoryDetail />
            </ProtectedRoute>
          }
        />
        <Route
          path="/mom-stories/queue"
          element={
            <ProtectedRoute>
              <MomStoriesQueue />
            </ProtectedRoute>
          }
        />
        <Route
          path="/mom-stories/answer/:questionId"
          element={
            <ProtectedRoute>
              <MomAnswerPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/travel"
          element={
            <ProtectedRoute>
                <TravelLog />
            </ProtectedRoute>
          }
        />
        <Route
          path="/non-rev"
          element={
            <ProtectedRoute>
                <NonRevTravel />
            </ProtectedRoute>
          }
        />
        <Route
          path="/flights"
          element={
            <ProtectedRoute>
              <FlightsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/cruise-planning"
          element={
            <ProtectedRoute>
                <CruisePlanning />
            </ProtectedRoute>
          }
        />

        <Route
          path="/calendar"
          element={
            <ProtectedRoute>
                <CalendarPage />
            </ProtectedRoute>
          }
        />

        {/* Buzzer Routes - Public for party access */}
        <Route path="/buzzer" element={<BuzzerLanding />} />
        <Route path="/buzzer/host" element={<BuzzerHost />} />
        <Route path="/buzzer/client" element={<BuzzerClient />} />
        <Route path="/ballpark" element={<BallparkLanding />} />
        <Route path="/ballpark/:code" element={<BallparkGame />} />
        <Route path="/scattergories" element={<ScattergoriesLanding />} />
        <Route path="/scattergories/:code" element={<ScattergoriesGame />} />
        <Route path="/justone" element={<JustOneLanding />} />
        <Route path="/justone/:code" element={<JustOneGame />} />
        <Route path="/metronome" element={<Metronome />} />

        <Route
          path="/dymock-history"
          element={
            <ProtectedRoute>
              <DymockHistory />
            </ProtectedRoute>
          }
        />
        <Route
          path="/ancestor-converts"
          element={
            <ProtectedRoute>
              <AncestorConverts />
            </ProtectedRoute>
          }
        />

        <Route path="/big-reveal" element={<BigReveal />} />

        <Route path="*" element={<NotFound />} />
      </Routes>
    </Box>
  )
}

export default AppRouter
